import React, { FC } from 'react'

// Components
import RowGroup from '../RowGroup'
import Button from 'components/Button'

// Types
import { BillingSeatsInfoFragment } from 'gqlTypes'

// Styles
import { Row, ContentCell } from '../PlanOverviewPanel/PlanOverviewPanel.styles'
import { StyledPluralize } from 'modules/workspace/modals/ChangeNextBillingCycleModal/ChangeNextBillingCycleModal.styles'

interface BillingForProps {
  seats: BillingSeatsInfoFragment
  onSeatScheduleChange: () => void
}

const BillingFor: FC<BillingForProps> = ({ seats, onSeatScheduleChange }) => {
  return (
    <Row>
      <RowGroup.HeadingCell width={['70%', 1 / 4]} alignItems="center">
        Billing For
      </RowGroup.HeadingCell>
      <ContentCell alignItems="center">
        <b>
          <StyledPluralize
            singular="Editor Seat"
            plural="Editor Seats"
            count={seats.scheduledSeatsTotal || seats.currentSeatsTotal}
            showCount
          />
        </b>
      </ContentCell>
      <ContentCell justifyContent="flex-end" alignItems="center">
        <Button variant="secondary" onClick={onSeatScheduleChange} tiny>
          Schedule Seat Changes…
        </Button>
      </ContentCell>
    </Row>
  )
}

export default BillingFor
